<style lang="less" scoped></style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form
          :model="detailForm"
          :rules="pageConfig.formRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="通知内容" prop="bannerMessage">
                <el-input
                  v-model="detailForm.bannerMessage"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item label="通知跳转" prop="bannerUrl">
                <el-input
                  v-model="detailForm.bannerUrl"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item label="应用app" prop="affiliationType">
                <el-select
                  class="full-width"
                  v-model="detailForm.affiliationType"
                  size="small"
                >
                  <el-option
                    v-for="item in applist"
                    :label="item.configName"
                    :value="item.configVal"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex-1"></div>
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig,
      editFlag: false,
      pageTitle: '通知新增',
      // 默认值设置
      detailForm: {
        bannerStatus: 'OFF',
        bannerStatusName: '关闭',
        bannerType: '01',
        bannerTypeName: '消息通知',
      },
      applist: [],//应用app数据列表
    }
  },
  methods: {
      //判断是否为编辑模式
    init() {
      if (this.$store.state.editId) {
        this.editFlag = true
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.$H.post(_, _.$A.config.list, { configType: '213' }).then((res) => {
        _.applist = res.data.data
      })
    },
    // 表单提交
    submitForm(formName) {
      let _ = this
      _.detailForm.corpNo = _.$store.state.corpNo
      _.detailForm.createdByName = _.$store.state.userInfo.userName
      let formData = new FormData()
      Object.keys(_.detailForm).forEach((key) => {
        formData.append(key, _.detailForm[key])
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$S.submitForm(
            _,
            _.$A.mobile.banner,
            _.editFlag,
            formData,
            pageConfig.listRouter
          )
        }
      })
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter,
      })
    },
  },
  mounted() {
    this.init()
    this.getFormInfo()
  },
}
</script>
